import {ProductSubscriptionLifecycleStatus} from 'src/openapi/admin/models/ProductSubscriptionLifecycleStatus';
import {SeatAssignmentStatus} from 'src/openapi/admin/models/SeatAssignmentStatus';

import type {UserSeatAssignment} from 'src/openapi/admin/models/UserSeatAssignment';

export const selectCurrentProductAssignments = (assignments: UserSeatAssignment[], today: string) => {
    const current = assignments.filter(assignment => assignment.status === SeatAssignmentStatus.ACTIVE &&
        (!assignment.subscriptionLifecycleStatus ||
            assignment.subscriptionLifecycleStatus === ProductSubscriptionLifecycleStatus.ACTIVE) &&
            assignment.subscriptionStartDate <= today && assignment.subscriptionEndDate >= today);
    current.sort((left, right) => left.subscriptionEndDate.localeCompare(right.subscriptionEndDate) ||
        left.subscriptionStartDate.localeCompare(right.subscriptionStartDate) || left.id.localeCompare(right.id));
    const products = new Map<string, UserSeatAssignment>();
    current.forEach(assignment => {
        if (!products.has(assignment.product.externalKey)) {
            products.set(assignment.product.externalKey, assignment);
        }
    });
    return products;
};
